import { IIconBase } from '..'

const updatePendingIcon = ({
  color = '#333752',
  height = 24,
  width = 25,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.5 7.75V13'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.5802 8.58003V15.42C21.5802 16.54 20.9802 17.58 20.0102 18.15L14.0702 21.58C13.1002 22.14 11.9002 22.14 10.9202 21.58L4.98016 18.15C4.01016 17.59 3.41016 16.55 3.41016 15.42V8.58003C3.41016 7.46003 4.01016 6.41999 4.98016 5.84999L10.9202 2.42C11.8902 1.86 13.0902 1.86 14.0702 2.42L20.0102 5.84999C20.9802 6.41999 21.5802 7.45003 21.5802 8.58003Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5 16.2V16.2999'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default updatePendingIcon
